import axiosConfig from "./axiosConfig";

export const getAllAuthor = async () => {
    try {
        const response = await axiosConfig().get('v1/authors');
        return response.data;
    } catch (error) {
        console.error('Error fetching rubriques:', error);
        throw error;
    }
}

export const getReviewerByReviewerCategory = async (reviewerCategory) => {
    try {
        const response = await axiosConfig.get(
            `v1/reviewers/grouped-by-category?category_id=${reviewerCategory}&include_empty=false`
        );
        return response.data;
    } catch (error) {
        console.error('Error getting reviewers by category:', error);
        throw error;
    }
};